export default "__VITE_ASSET__cTaC$RaY__"